import React from 'react';
import PropTypes from 'prop-types';
import { Provider, store } from '@instructure/quiz-core';
import TakeButton from '../TakeButton';
export var SDKTakeButton = function SDKTakeButton(_ref) {
  var onSubmitQuizSession = _ref.onSubmitQuizSession,
    iceTopNavBarEnabled = _ref.iceTopNavBarEnabled;
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(TakeButton, {
    onSubmitQuizSession: onSubmitQuizSession,
    iceTopNavBarEnabled: iceTopNavBarEnabled,
    "data-automation": "sdk-take-button"
  }));
};
SDKTakeButton.propTypes = {
  onSubmitQuizSession: PropTypes.func,
  iceTopNavBarEnabled: PropTypes.bool
};
SDKTakeButton.defaultProps = {
  onSubmitQuizSession: null,
  iceTopNavBarEnabled: false
};
export default SDKTakeButton;